import axios from 'axios';
import { customAxios } from '../../common/customAxios';
import { usersOwnTractorsApiUrl } from '../../product/queries/getUsersOwnTractors';
import { IOwnTractorImage } from './postMyOwnTractorImages';
import { ITractorImage } from './postUsersSellTractors';

export interface IPatchMyOwnTractorImagesParams {
  reqBody: {
    ownTractorId: string;
    images: IOwnTractorImage[];
  };
}

export const patchMyOwnTractorImages = ({ reqBody }: IPatchMyOwnTractorImagesParams) => {
  return customAxios.patch(`${usersOwnTractorsApiUrl}/mine/${reqBody.ownTractorId}/images`, reqBody.images);
};
